/**
 * @internal Backs `artis.v1.grid.selection`: a publish/subscribe fan-out. The producer
 * seam calls `set`; consumers subscribe through {@link GridSelectionApi}, not this class.
 */
export class SelectionStore {
    subs = new Set();
    set = (selection) => {
        for (const cb of this.subs)
            cb(selection);
    };
    subscribe = (cb) => {
        this.subs.add(cb);
        return () => void this.subs.delete(cb);
    };
}
//# sourceMappingURL=selectionStore.js.map